import React, { Component } from 'react';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';
import { connect } from 'react-redux';
import TripItem from './TripItem';
import ReservationUIHelper from 'components/components/dashboard/utils/ReservationUIHelper';
import { DIRECTION_FLIGHT, DIRECTION_ARRIVE }
  from 'components/components/booking/utils/FlightConstants';
import Slide from 'components/components/dashboard/components/Slide';
import { setReservationToReview, setFilterDateInTrips, setMyTrips } from 'components/actions/serviceActions';
// import { SingleDatePicker } from 'react-dates';
import axios from 'components/AppRequest';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderBack from '../components/HeaderBack';

class AllReservations extends Component {
  state = {
    date: null,
    focused: false,
  }

  handleChangeDate = (date) => {
    if (date) {
      var formattedDate = date.format("YYYY-MM-DD");
    } else {
      var formattedDate = null;
    }
    axios.get('/pwa/dashboard/all-reservations', { params: { date: formattedDate } })
      .then(response => {
        this.props.setMyTrips(response.data);
      })
      .catch(err => {
        console.log("err", err);
      });
    this.props.setFilterDateInTrips(formattedDate);
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  render() {
    const { myTripsDate } = this.props;
    var date = myTripsDate ? moment(myTripsDate) : null;
    return (
      <div className="content" style={{ padding: '0', overflow: 'auto' }}>
        <HeaderBack locale={this.props.locale} />
        <div style={{ padding: '20px' }}>
          <div className="head-icon">
            <h2><T>content.dashboard.myTrips</T></h2>
            <div className="single-date-picker">

            </div>
          </div>

          {this.props.myTrips.length === 0 && (
            <div className="message message--info" style={{ marginBottom: '25px' }}>
              <p><T>content.dashboard.notFoundTrips</T></p>
            </div>
          )}
          <ul className="list-trips">
            {this.props.myTrips.map((trip, i) => {
              var helper = new ReservationUIHelper(
                trip,
                this.props.locale,
                this.props.setReservationToReview
              );
              var statusData = helper.getStatusInfo();
              return (
                <TripItem
                  address={helper.getAddressPhrase()}
                  addressFirst={helper.getAddress(DIRECTION_FLIGHT)}
                  addressSecond={helper.getAddress(DIRECTION_ARRIVE)}
                  adults={trip.adults}
                  arrival={helper.getPlaceTo()}
                  children={trip.children}
                  complete={statusData.isPositive}
                  canRateTrip={helper.canRateTrip()}
                  canSeeRating={helper.canSeeRate()}
                  data={helper.getDate()}
                  departure={helper.getPlaceFrom()}
                  icon={statusData.tripIcon}
                  invoice={trip.can_generate_invoice}
                  invoiceHash={trip.invoice_hash}
                  key={trip.id}
                  paymentToDriver={trip.payment_to_driver}
                  price={trip.price}
                  rating={trip.driver_rate}
                  ratingCall={null}
                  reviewLink={statusData.tripReviewLink}
                  status={statusData.status}
                  trans={this.trans}
                />
              );
            })}
          </ul>
          <Slide />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    myTrips: state.service.myTrips,
    myTripsDate: state.service.myTripsDate,
  }
}

export default connect(
  mapStateToProps,
  { setReservationToReview, setFilterDateInTrips, setMyTrips }
)(AllReservations);
